var Dataset = /** @class */ (function () {
    function Dataset(_a) {
        var id = _a.id;
        this.id = id;
    }
    Dataset.fromJSON = function (json) {
        var id = Object.assign({}, json).id;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        return new Dataset({
            id: id,
        });
    };
    return Dataset;
}());
export default Dataset;
